import { useConfig } from '@crystal/config'
import { useFeatureFlags } from '@crystal/feature-flags'
import { Translations, useTranslations } from '@crystal/translator'

import { AccountPortalConfig } from '../config'
import { Provider, SuggestSocialLogin } from '../config/types'

import styles from './account-portal.module.scss'
import { SocialLoginButton } from './SocialLoginButton'

export const SuggestSocialLoginOption = ({ email }: { email: string }) => {
  const t = useTranslations<Translations>()
  const { ACCOUNT_SUGGEST_SOCIAL_LOGIN } = useFeatureFlags()
  const { suggestSocialLogin, socialLoginProviders } = useConfig<AccountPortalConfig>()
  const matchEmailToSocialProvider = getMatchEmailToSocialProvider(suggestSocialLogin, socialLoginProviders)

  if (!ACCOUNT_SUGGEST_SOCIAL_LOGIN) {
    return null
  }

  const provider = matchEmailToSocialProvider(email)
  return provider ? (
    <div>
      <p className={styles['subtitle']}>{t('suggest.social.login.option')}</p>
      <SocialLoginButton compactButtons providerId={provider.id} className={styles['suggested-social-cta']} />
    </div>
  ) : null
}

const getMatchEmailToSocialProvider =
  (suggestLoginConfig: SuggestSocialLogin, providers: Array<Provider>) => (email: string) => {
    try {
      const domain = email.split('@')[1]
      const providerId = suggestLoginConfig.find(item => item.domains.includes(domain))?.id
      return providerId ? providers.find(provider => provider.id === providerId) : null
    } catch (error) {
      return null
    }
  }
